import gql from 'graphql-tag';
import apiRequest from './apiRequest';
// @ts-ignore
import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import invariant from 'invariant';

import { ApolloQueryResult } from 'apollo-client';
import { DocumentNode } from 'graphql';
import { FetchResult } from 'apollo-link';

export default class RemindAPI {
  static request(
    endpoint: string,
    method: string = 'GET',
    data: Object = {},
    isJSON: boolean = true
  ): Promise<any> {
    return apiRequest(endpoint, method, data, isJSON);
  }

  static execute<T>(args: {
    query?: DocumentNode;
    mutation?: DocumentNode;
    variables?: any;
    forceFetch?: boolean;
    refetchQueries?: { query: DocumentNode; variables?: Object }[];
  }): Promise<T> {
    const { query, mutation, variables, forceFetch, refetchQueries } = args;
    invariant(query || mutation, 'GraphQL queries must include either a query or mutation');
    const apollo = getApolloClientSingleton();

    let promise = null;
    const variablesOrDefault = variables || {};
    const forceFetchOrDefault = forceFetch || false;

    if (query) {
      const options = {
        variables: variablesOrDefault,
        fetchPolicy: forceFetchOrDefault ? 'network-only' : 'cache-first',
      };

      promise = apollo.query<T>(Object.assign({}, options, { query }));
    } else {
      const options = refetchQueries
        ? { variables: variablesOrDefault, refetchQueries }
        : { variables: variablesOrDefault };
      promise = apollo.mutate<T>(
        Object.assign({}, options, { mutation } as { mutation: DocumentNode })
      );
    }

    return (promise as Promise<ApolloQueryResult<T>>).then(
      (response: ApolloQueryResult<T>) => response.data
    );
  }

  static registerWatchQuery(args: {
    query: DocumentNode;
    variables?: any;
    onQueryChange: (data: Object) => void;
  }): void {
    const { query, variables, onQueryChange } = args;
    const variablesOrDefault = variables || {};

    function next(results: ApolloQueryResult<any>) {
      if (results.loading === false) {
        onQueryChange(results.data);
      }
    }

    const options = { query, variables: variablesOrDefault };
    const queryObserver = getApolloClientSingleton().watchQuery(options);
    queryObserver.subscribe({ next });
  }
}

export const ERRORS = {
  birthdate_required: 'birthdate_required',
  not_found: 'not_found',
  cannot_respond_to_closed_event: 'cannot_respond_to_closed_event',
};

// @ts-ignore
if (__DEV__ && typeof window !== 'undefined') {
  // @ts-ignore
  window.gql = gql;
  // @ts-ignore
  window.RemindAPI = RemindAPI;
}
